import React, { useEffect, useState } from "react";
import { Text, Box, useMediaQuery } from "native-base";
import "./style.css";
import { COLORS } from "../../utils/colors";
import { uploadCloudIconSVG } from "../../utils/svg";
import config from "../../utils/config";
import { Toaster } from "../../components/toaster";
import { COMMONFONTSIZE, COMMONFONTWEIGHT } from "../../utils/fonts";
import { MOBILE_VIEW_WIDTH } from "../../utils/screens";
import { isVideoByExtension, isImageByExtension } from "../../utils/fileUtils";

const FileUploader = ({
  files = [],
  templates = false,
  setFiles = () => {},
  multiple = false,
  types = ".xls, .xlsx",
  show = true,
  images = false,
  keyForReset = 0,
  accept = ["xls", "xlsx"],
  imageRestriction = false,
  isDisabled = false,
  href = config.peopleTemplateUrl,
  forceRemount = false,
}) => {
  const hiddenFileInput = React.useRef(null);
  const toaster = Toaster();
  const [MobileWindow] = useMediaQuery({
    maxWidth: MOBILE_VIEW_WIDTH,
  });
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    setShowError(false);
  }, [forceRemount]);

  const SquareIcon = ({ onIconClick }) => {
    return (
      <Box
        mt={1}
        size={8}
        bg={COLORS.FILE_UPLOAD_COLOR}
        borderRadius={4}
        justifyContent="center"
        alignItems="center"
        position="relative"
        onClick={onIconClick}
        style={{ cursor: "pointer" }}
      >
        <div className="plus-bar horizontal"></div>
        <div className="plus-bar vertical"></div>
      </Box>
    );
  };

  const handleUploadFiles = (fileData) => {
    setShowError(false);
    let upload = [];
    // let upload = [...files];
    // let result = fileData.some((file) => {
    //   const maxSize = 104857600;
    //   if (
    //     file.size < maxSize &&
    //     /^[^<>~"`{}\\]*$/.test(file.name) &&
    //     upload.findIndex((f) => f.name === file.name) === -1
    //   ) {
    //     upload.push(file);
    //   }
    //   return upload;
    // });
    // let upload = [];
    fileData.forEach((file) => {
      const maxSize = 104857600;
      if (
        file.size < maxSize &&
        /^[^<>~"`{}\\]*$/.test(file.name) &&
        file.name.length <= 200
      )
        if (
          files.length > 0 &&
          files?.findIndex((f) => f.name === file.name) === -1
        ) {
          upload.push(file);
        } else if (!files || files.length === 0) {
          upload.push(file);
        }
    });
    setFiles(upload);
  };

  const handleUploadImages = (fileData) => {
    const upload = [...files];
    fileData.forEach((file) => {
      const isVideo = isVideoByExtension(file);
      const maxSize = isVideo ? 104857600 : 52428800; // 100MB for videos, 50MB for images
      if (
        file.size < maxSize &&
        /^[^<>~"`{}\\]*$/.test(file.name) &&
        file.name.length <= 200
      ) {
        const index = upload.findIndex((f) => f.name === file.name);
        if (index === -1) {
          upload.push(file);
        } else {
          upload[index] = file;
        }
      }
    });
    if (upload.length > 0) setFiles(upload);
  };

  const handleChange = (event) => {
    setShowError(false);
    let uploadFile = false;
    if (event.target.files) {
      for (let i = 0; i < event.target.files.length; i++) {
        const file = event.target.files[i];
        const fileExtension = file.name.split(".").pop().toLowerCase();
        if (!accept.includes(fileExtension)) {
          toaster("Only " + accept.toString() + "allowed", "error", "error");
          return;
        }
        //  1 MB = 1048576 Bytes
        // 50 MB = 52428800 Bytes
        // 100 MB = 104857600 Bytes
        const isVideo = isVideoByExtension(file);
        const maxSize = isVideo ? 104857600 : (images ? 52428800 : 104857600);
        if (file.size > maxSize) {
          uploadFile = true;
          setShowError(true);
          setErrorMessage(
            isVideo
              ? event.target.files.length > 1
                ? "Some videos exceed the maximum allowed size of 100MB"
                : "Video exceeds the maximum allowed size of 100MB"
              : images
              ? event.target.files.length > 1
                ? "Some images exceed the maximum allowed size of 50MB"
                : "Image exceeds the maximum allowed size of 50MB"
              : "File exceeds the maximum allowed size of 100MB"
          );
        }
        if (!/^[^<>~"`{}\\]*$/.test(file.name)) {
          uploadFile = true;
          setShowError(true);
          setErrorMessage(
            images
              ? "Image name should not contain these characters"
              : "File name should not contain these characters"
          );
        }
        if (file.name.length > 200) {
          uploadFile = true;
          setShowError(true);
          setErrorMessage(
            images
              ? "Image name should not exceed 200 characters"
              : "File name should not exceed 200 characters"
          );
        }
      }
      const chosenFiles = Array.prototype.slice.call(event.target.files);
      // !uploadFile &&
      images
        ? handleUploadImages(chosenFiles)
        : !uploadFile && handleUploadFiles(chosenFiles);
    }
    // const chosenFiles = Array.prototype.slice.call(event.target.files);
    // images ? handleUploadImages(chosenFiles) : handleUploadFiles(chosenFiles);
  };

  const handleClick = () => {
    hiddenFileInput.current.value = "";
    hiddenFileInput.current.click();
  };

  return (
    <p className="upload_files">
      <div className="center-content">
        <span>{uploadCloudIconSVG}</span>
        <Text mt={1} textAlign="center">
          Browse and choose the files you want to <br /> upload from your
          computer
        </Text>
        <SquareIcon onIconClick={handleClick} />
        {showError && (
          <Text color={COLORS.REJECT_TEXT_COLOR}>{errorMessage}</Text>
        )}
        <input
          key={keyForReset}
          type="file"
          accept={types}
          ref={hiddenFileInput}
          onChange={handleChange}
          className="uploadbtn"
          style={{ display: "none" }}
          multiple={multiple}
          disabled={isDisabled}
        />
        {show &&
          files &&
          files.length > 0 &&
          files.map((file) => {
            return (
              <Text
                fontSize={COMMONFONTSIZE.LARGE_FONT_SIZE}
                fontWeight={COMMONFONTWEIGHT.MEDIUM_FONT_WEIGHT}
                textAlign={"center"}
                wordBreak="break-word"
                px={3}
                pt={2}
              >
                {file.name}
              </Text>
            );
          })}
        {templates && (
          <Box mt={6}>
            <a
              href={href}
              style={{
                color: "#00A50F",
                fontSize: "12px",
                textDecoration: "none",
              }}
            >
              <Text
                fontWeight="700"
                color={COLORS.THEME_COLOR}
                textAlign="center"
              >
                Download templates
              </Text>
            </a>
          </Box>
        )}
      </div>
    </p>
  );
};

export default FileUploader;
